import React from "react"

import { applyImageCloudinaryTransforms } from "utils/applyCloudinaryTransforms"

import { BylineAuthor } from "../base/styles"
import { Card, Preheading } from "./styles"

const ProductHightlightCard = ({ preheading, byline, image, ...props }) => (
  <Card
    {...props}
    topLeftElement={<Preheading dangerouslySetInnerHTML={{ __html: preheading }} />}
    background={
      image &&
      applyImageCloudinaryTransforms(image, "c_fill,g_auto,w_105,h_105,q_90,f_auto,fl_lossy")
    }
    bylineElement={<BylineAuthor>{byline}</BylineAuthor>}
  />
)

export default ProductHightlightCard
